// src/hypotheken/hypotheken-berekening/app/accordion-steps.config.ts

import { AccordionStep } from '@hb/domain';
import { ACCORDION_STEPS_CONFIG, AccordionStepConfig } from '@hb/services/accordion-state/accordion-config.token';
import { ApplicantsComponent } from '@hb/modules/applicants/applicants.component';
import { FinancialObligationsComponent } from '@hb/modules/financial-obligations/financial-obligations.component';
import { PropertyComponent } from '@hb/modules/property/property.component';
import { ExtraAssetComponent } from '@hb/modules/extra-asset/extra-asset.component';
import { MortgageCalculationComponent } from '@hb/modules/mortgage-calculation/mortgage-calculation.component';

import { Provider } from '@angular/core';

const accordionStepsConfig: AccordionStepConfig[] = [
    {
        step: AccordionStep.INCOME,
        titleKey: 'main.main-accordion.income.title',
        component: ApplicantsComponent,
        icon: 'calculator'
    },
    {
        step: AccordionStep.FINANCIAL_OBLIGATION,
        titleKey: 'main.main-accordion.financial-obligations.title',
        component: FinancialObligationsComponent,
        icon: 'accounts'
    },
    {
        step: AccordionStep.PROPERTY,
        titleKey: 'main.main-accordion.single.property.title',
        component: PropertyComponent,
        icon: 'house'
    },
    {
        step: AccordionStep.EXTRA_ASSET,
        titleKey: 'main.main-accordion.extra-asset.title',
        component: ExtraAssetComponent,
        icon: 'moneybag'
    },
    {
        step: AccordionStep.MORTGAGE,
        titleKey: 'main.main-accordion.mortgage-calculation.title',
        component: MortgageCalculationComponent,
        icon: 'inzicht-belastingen-toeslagen'
    }
];

export const provideAccordionSteps = (): Provider => ({
    provide: ACCORDION_STEPS_CONFIG,
    useValue: accordionStepsConfig
});
